import { useMemo } from "react";
import moment from "moment";

const useProductData = (fetchData) => {
  const data = Array.isArray(fetchData) ? fetchData : []; // Ensure `data` is an array

  const formattedData = useMemo(() => {
    const rows = [];

    if (data.length > 0) {
      data.forEach((order, index) => {
        const customer = order.Customer || {};
        const orderItems = Array.isArray(order.Order_items)
          ? order.Order_items
          : [];

        // console.log("order");

        const formattedOrderItems = orderItems.map((item) => {
          const product = item.Product || {};

          return {
            id: item.id || "",
            product_id: product.product_id || "",
            product_code: product.product_code || "",
            product_name: product.product_name || "",
            category_id: product.category_id || "",
            detail: product.detail || "",
            product_price: product.price || "",
            product_code_com: product.product_code_com || "",
            blemishes: product.blemishes || "",
            notes: product.notes || "",
            total_amount: product.total_amount || 0,
            total_price: product.total_price || "0.00",
            size: product.size || "",
            remaining_amount: product.remaining_amount || 0,
            pictures: Array.isArray(product.Pictures)
              ? product.Pictures.map((picture) => ({
                  id: picture.id,
                  picture: picture.pic
                    .split("http")
                    .filter(Boolean)
                    .map((url) => `http${url.trim()}`),
                }))
              : [],
          };
        });

        const row = {
          id: order.id || index,
          order_code: order.order_code || "",
          qrcode: order.qrcode || "",
          company_id: order.company_id || "",
          order_status: order.order_status || "",
          count_product_amount: order.count_product_amount || "",
          count_type_product: order.count_type_product || "",
          payment_channel: order.payment_channel || "",
          created_date: order.created_at
            ? moment(order.created_at).format("DD/MM/YYYY\n เวลา HH:mm:ss น.")
            : "",
          updated_date: order.updated_at
            ? moment(order.updated_at).format("DD/MM/YYYY\n เวลา HH:mm:ss น.")
            : "",
          prefix: customer.prefix || "",
          customer_name: customer.name || "",
          idcard: customer.idcard || "",
          phonenumber: customer.phonenumber || "",
          address: customer.address || "",
          nationality: customer.nationality || "",
          customer_image: customer.image || "",
          picture:
            formattedOrderItems.length > 0 &&
            formattedOrderItems[0].pictures.length > 0
              ? formattedOrderItems[0].pictures
              : [], // กรณีที่ไม่มีข้อมูล
          order_items: formattedOrderItems,
          total_product_price: formattedOrderItems.reduce(
            (sum, item) => sum + parseFloat(item.total_price || "0"),
            0
          ),
        };

        rows.push(row);
      });
    }

    return rows;
  }, [data]);

  return formattedData;
};

export default useProductData;
